<template>
  <div
    id="app"
    v-loading.body.fullscreen="loading"
    element-loading-text="加载中..."
    element-loading-customClass="loading"
  >
    <!--<img src="./assets/logo.png">-->
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "app",
  created: function () {
    /*this.$store.commit({
      type: "setPlatform",
      platform: this.$router.params.platform
    });*/
    /*this.api.user.status({}).then(response => {
      if (!response.data.errorCode) {
        if (response.data.data) {
          this.$store.commit({
            type: "loginIn",
            name: response.data.data.name,
            userName: response.data.data.phone,
            id: response.data.data.id,
            token: response.data.data.token
          });
        } else {
          this.$store.commit("logout");
        }
      }
    });*/
  },
  methods: {},
  computed: {
    ...mapState(["loading"]),
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
}
html,
body {
  height: 100%;
}
body {
  margin: 0px;
  padding: 0px;
  font-size: 12px;
}
.el-loading-mask {
  background: rgba(0, 0, 0, 0.5) !important;
}
.el-message-box{
  max-width: 90% !important;
}
.el-message{
  min-width: 300px;
  max-width: 90% !important;
}
</style>



// WEBPACK FOOTER //
// App.vue?70ec5912